module.exports = __webpack_public_path__ + "static/img/report_icon1.ee4a1a52.png";